/**
 * L2-P1: moved to @miq/shared-models (models/country.model.ts). This shim keeps the old
 * import path working; new code should import from '@miq/shared-models'.
 */
export {
	CountryId,
	HK_CHINA_COUNTRY_IDS,
	UK_CIQ_INTEGRATION_CATALOGS,
	United_States_of_America,
} from '@miq/shared-models';
